// Need to use the React-specific entry point to import createApi
import type {
  FileResponse,
  GetListResponseOfSelectOption,
  GetListResponseOfUserGroupSimpleResponse,
  GetUserGroupListRequest,
  GetUserGroupListRequestV2,
  UserGroupRequest,
  UserGroupResponse,
} from 'src/api/ProactApiClient';
import {userGroupApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const userGroupApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getUserGroupSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetUserGroupListRequest
    >({
      queryFn: clientQuery(params =>
        userGroupApiClient.listSelectOptions(params)
      ),
      providesTags: ['UserGroups'],
    }),
    getUserGroupList: builder.query<
      GetListResponseOfUserGroupSimpleResponse,
      GetUserGroupListRequest
    >({
      queryFn: clientQuery(params => userGroupApiClient.list(params)),
      providesTags: ['UserGroups'],
    }),
    getUserGroupListV2: builder.query<
      GetListResponseOfUserGroupSimpleResponse,
      GetUserGroupListRequestV2
    >({
      queryFn: clientQuery(params => userGroupApiClient.listV2(params)),
      providesTags: ['UserGroups'],
    }),
    getUserGroup: builder.query<UserGroupResponse, number>({
      queryFn: clientQuery(id => userGroupApiClient.get(id)),
      providesTags: ['UserGroups'],
    }),
    createUserGroup: builder.mutation<UserGroupResponse, UserGroupRequest>({
      queryFn: clientQuery(request => userGroupApiClient.create(request)),
      invalidatesTags: ['UserGroups'],
    }),
    updateUserGroup: builder.mutation<UserGroupResponse, UserGroupRequest>({
      queryFn: clientQuery(request => userGroupApiClient.update(request)),
      invalidatesTags: ['UserGroups'],
    }),
    deleteUserGroup: builder.mutation<FileResponse | null, number>({
      queryFn: clientQuery(id => userGroupApiClient.delete(id)),
      invalidatesTags: ['UserGroups'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserGroupListQuery,
  useGetUserGroupSelectOptionsQuery,
  useGetUserGroupListV2Query,
  useGetUserGroupQuery,
  useCreateUserGroupMutation,
  useUpdateUserGroupMutation,
  useDeleteUserGroupMutation,
} = userGroupApi;
